import { useEffect, useState } from 'react'

/**
 * Trả về true khi viewport rộng >= `px`. Dùng để render CÓ ĐIỀU KIỆN (mount/
 * unmount) các nhánh nặng tài nguyên theo viewport — khác với ẩn bằng CSS
 * (`hidden`) vốn giữ component sống và vẫn chạy effect (poll, stream camera...).
 *
 * SSR-safe: khởi tạo `false` để tránh hydration mismatch; effect sync với
 * viewport thật ở client.
 */
export function useMinWidth(px: number): boolean {
    const [matches, setMatches] = useState(false)

    useEffect(() => {
        // SSR / môi trường không có matchMedia (jsdom mặc định): giữ `false`.
        if (typeof window === 'undefined' || !window.matchMedia) return
        const query = window.matchMedia(`(min-width: ${px}px)`)
        const update = () => setMatches(query.matches)
        update()
        query.addEventListener('change', update)
        return () => query.removeEventListener('change', update)
    }, [px])

    return matches
}
